import { DiagnosticScope } from '../scope';
import { BaseScriptBuilder } from './BaseScriptBuilder';
export class DiagnosticScriptBuilder extends BaseScriptBuilder {
    constructor() {
        super(...arguments);
        this.mutableCapturedHelpersSet = new Set();
    }
    emitHelper(node, options, helper) {
        if (!this.mutableCapturedHelpersSet.has(helper)) {
            this.mutableCapturedHelpersSet.add(helper);
            helper.emitGlobal(this, node, options);
        }
        helper.emit(this, node, options);
    }
    emitOp() {
    }
    emitPushInt() {
    }
    emitPushBoolean() {
    }
    emitPushString() {
    }
    emitPushBuffer() {
    }
    emitJmp() {
    }
    emitBytecode() {
    }
    emitCall() {
    }
    emitSysCall() {
    }
    emitLine() {
    }
    getLinkedScriptHash() {
        return undefined;
    }
    createScope() {
        return new DiagnosticScope();
    }
}

//# sourceMappingURL=DiagnosticScriptBuilder.js.map
